export const getFlowsheetsList = () => {
    console.log('Fetching flowsheets from:', '/flowsheets/');
    return fetch('/flowsheets/',{mode: 'cors'})
        .then(response => {
            console.log('Response status:', response.status);
            console.log('Response ok:', response.ok);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .catch(error => {
            console.error('Error in getFlowsheetsList:', error);
            throw error;
        });
};

export const uploadFlowsheet = (data) => {
    return fetch('/flowsheets/upload_flowsheet', {
        method: 'POST', 
        mode: 'cors',
        body: data
    });
}; 

export const deleteFlowsheet = (id) => {
    return fetch('/flowsheets/'+id+'/remove_flowsheet', {
        method: 'POST',
        mode: 'cors'
    });
}; 